import { FormsModule } from '@angular/forms';
import { ModalBaseModule } from 'Angular/features/components/modals/modal-base/modal-base.module';
import * as i0 from "@angular/core";
export class PdfTitleModalModule {
}
PdfTitleModalModule.ɵfac = function PdfTitleModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PdfTitleModalModule)(); };
PdfTitleModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PdfTitleModalModule });
PdfTitleModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [ModalBaseModule, FormsModule] });
